/* Heureka product attribution: synchronous cookie adapter for the live SDK v2. */
(()=>{
 'use strict';
 if(window.__pateaHeurekaProductV1 || window.Shopify?.designMode)return;
 const state=window.__pateaHeurekaProductV1={version:'1.1.0',status:'WAITING_PRIVACY'};
 let privacy,stored=false;
 function productUrl(){
  try{
   const u=new URL(location.href);
   if(u.origin!=='https://pateabotanica.com'||u.username||u.password||u.hash||u.search.length>1800)return null;
   if(!/^\/(?:cs\/|en\/)?(?:(?:collections\/[a-z0-9-]+\/)?products\/[a-z0-9-]+)\/?$/.test(u.pathname))return null;
   const keys=new Set();
   for(const [key,value] of u.searchParams){
    if(keys.has(key))return null;keys.add(key);
    if(key==='variant'){if(!/^[1-9][0-9]{0,19}$/.test(value))return null;}
    else if(['hgtid','aku'].includes(key)){if(!/^[A-Za-z0-9_.~%-]{1,512}$/.test(value))return null;}
    else if(['gclid','dclid','gbraid','wbraid','fbclid','msclkid','sznclid','sznaiid'].includes(key)){if(!/^[A-Za-z0-9_.~-]{1,256}$/.test(value))return null;}
    else if(['utm_source','utm_medium','utm_campaign','utm_content','utm_term','utm_id'].includes(key)){if(!/^[A-Za-z0-9_.~-]{1,120}$/.test(value))return null;}
    else return null;
   }
   return u;
  }catch{return null;}
 }
 function allowed(){try{return privacy.analyticsProcessingAllowed()===true&&privacy.marketingAllowed()===true&&privacy.saleOfDataAllowed()===true;}catch{return false;}}
 function erase(){try{document.cookie='hg_ocm_id=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=pateabotanica.com; Secure; SameSite=Lax';document.cookie='hg_ocm_id=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; Secure; SameSite=Lax';}catch{}}
 function sync(){
  if(!allowed()){if(stored){erase();stored=false;}state.status='CONSENT_BLOCKED';return;}
  const u=productUrl();if(!u){state.status='PRIVATE_URL_BLOCKED';return;}
  if(stored)return;
  // Official SDK p() uses the first of hgtid/aku, encoded JSON and 30-day expiry.
  // No asynchronous SDK can execute after a grant is revoked.
  const key=['hgtid','aku'].find(k=>u.searchParams.has(k));
  if(!key){state.status='NO_HEUREKA_CLICK';return;}
  try{
   const data={};data[key]=u.searchParams.get(key);
   const expires=new Date(Date.now()+30*86400000).toUTCString();
   document.cookie='hg_ocm_id='+encodeURIComponent(JSON.stringify(data))+'; expires='+expires+'; path=/; domain=pateabotanica.com; Secure; SameSite=Lax';
   stored=true;state.status='ATTRIBUTION_WRITE_RECEIPT_UNVERIFIED';
  }catch{state.status='COOKIE_UNAVAILABLE';}
 }
 document.addEventListener('visitorConsentCollected',sync);
 if(!productUrl()){state.status='PRIVATE_URL_BLOCKED';return;}
 try{
  const s=window.Shopify;if(typeof s?.loadFeatures!=='function'){state.status='PRIVACY_UNAVAILABLE';return;}
  s.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],error=>{if(error||!s.customerPrivacy){state.status='PRIVACY_UNAVAILABLE';return;}privacy=s.customerPrivacy;sync();});
 }catch{state.status='PRIVACY_UNAVAILABLE';}
})();
